import { memo, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { useFetchJobTitles } from '../../api/apiHooks'
import { SearchableInput } from '../SearchableInput'
import { Inputs } from './GenerateMentorForm/GenerateMentorForm'

interface IJobTitleSelectProps {
  defaultValue?: string
  disabled?: boolean
}
type JobTitlePage = { items: string[] }

const JobTitleSelect: React.FC<IJobTitleSelectProps> = memo(
  ({ disabled, defaultValue }) => {
    const { setValue } = useFormContext<Inputs>()
    const [searchJobTitle, setSearchJobTitle] = useState<string>('')
    const { data, isFetching, hasNextPage, isFetchingNextPage, fetchNextPage } =
      useFetchJobTitles(searchJobTitle, !disabled)

    const handleSearchChange = (query: string) => {
      setSearchJobTitle(query)
      if (query.trim()) {
        setValue('jobTitle', query)
      }
    }

    const jobTitlesSearchResult = useMemo(
      () =>
        data?.pages.map((page: JobTitlePage) => page.items).flat() ||
        ([] as string[]),
      [data],
    )

    const onJobTitleSelect = (value: string) => {
      setValue('jobTitle', value)
      if (!value) {
        setSearchJobTitle('')
      }
    }

    return (
      <SearchableInput
        searchResult={jobTitlesSearchResult}
        onSearchChange={handleSearchChange}
        isFetching={isFetching}
        wrapperClassName="tc-mv-input-wrapper"
        placeholder="Start typing..."
        onSelect={onJobTitleSelect}
        fetchNextPage={fetchNextPage}
        needFetchNextPage={hasNextPage && !isFetchingNextPage}
        disabled={disabled}
        defaultValue={defaultValue}
      />
    )
  },
)

export { JobTitleSelect }
